import { render, staticRenderFns } from "./DomainsProductEntry.vue?vue&type=template&id=c979c306&"
import script from "./DomainsProductEntry.vue?vue&type=script&lang=js&"
export * from "./DomainsProductEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports